/**
 * tdesign v1.0.3
 * (c) 2023 tdesign
 * @license MIT
 */

var transferDefaultProps = {
  defaultChecked: [],
  data: [],
  direction: "both",
  search: false,
  showCheckAll: true,
  targetSort: "original",
  title: [],
  defaultValue: []
};

export { transferDefaultProps };
//# sourceMappingURL=defaultProps.js.map
